import { render, staticRenderFns } from "./GeographicInfo.vue?vue&type=template&id=607b901b&scoped=true&"
import script from "./GeographicInfo.vue?vue&type=script&lang=js&"
export * from "./GeographicInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeographicInfo.vue?vue&type=style&index=0&id=607b901b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b901b",
  null
  
)

export default component.exports